import { useQuery } from "react-query";
import { getEntity } from "../../../../actions/Utilities/Entity";

export const useEntity = () => {
  return useQuery("GetEntity", getEntity, {
    refetchOnWindowFocus: false,
  });
};
